import type { SxStyle, SxStyleFunc } from '@aibees/shared/theme';

export const root: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
};

export const closeIcon: SxStyle = {
  cursor: 'pointer',
};

export const icon: SxStyleFunc<boolean | undefined> = (onClick) => ({
  cursor: onClick ? 'pointer' : 'default',
});
